/**
 * Normaliza o nome de uma OTA para uma chave padronizada.
 * Por exemplo, todas as variações de B2B são convertidas para 'b2b'.
 */
export const normalizeOtaName = (name: string): string => {
  const normalized = name?.toLowerCase().trim() || '';

  if (normalized === 'b2b.reservas' || normalized === 'b2b reservas' || normalized === 'b2b') {
    return 'b2b';
  }

  return normalized;
};
